import axios from 'axios';
import qs from 'qs';
import { BASE_SITE } from '../apis';
import { handleSetBackdropLoading } from 'reduxx/actions/loaders';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { actionLogOutUser } from 'reduxx/actions/pages/user/login';

interface ApiRequestProps {
  dispatch: any;
  endpoint: string;
  method?: 'get' | 'post' | 'put' | 'delete';
  data?: any;
  token?: string | null;
  onSuccess?: (res: any) => void;
  onError?: (err: any) => void;
  successMessage?: string | null;
  showSnackbar?: boolean;
  autoLoading?: boolean;
  isForm?: boolean;
}

const apiRequest = async ({
    dispatch,
    endpoint,
    method = 'get',
    data = {},
    token = null,
    onSuccess = () => {},
    onError = () => {},
    successMessage = null,
    showSnackbar = true,
    autoLoading = true,
    isForm = true, // تعیین نوع content-type
}: ApiRequestProps): Promise<void> => {

    dispatch(
        handleSetOpenCustomSnackbar(
            false
        )
    );
    if (autoLoading) dispatch(handleSetBackdropLoading(true));

    try {
        const response = await axios({
            method,
            url: BASE_SITE + endpoint,
            data: isForm ? qs.stringify(data) : data,
            headers: {
                'Accept': 'application/json',
                'Content-Type': isForm ? 'application/x-www-form-urlencoded' : 'application/json',
                ...(token && { 'Authorization': token }),
            },
        });

        const res = response.data;

        if (res.status === 'ok') {
            onSuccess(res);
            if (successMessage && showSnackbar) {
            	dispatch(
            		handleSetOpenCustomSnackbar(
            			true, 
            			{
            				message: successMessage, 
            				severity: 'success', 
            				vertical: 'top', 
            				horizontal: 'right'
            			}
        			)
        		);
            }
            if(res.code !== undefined)
                dispatch(
                    handleSetOpenCustomSnackbar(
                        true, 
                        {
                            message: `کد: ${res.code}`, 
                            severity: 'warning', 
                            vertical: 'top', 
                            horizontal: 'center'
                        }
                    )
                );
        } else {
            if(res.status === 're_login') {
                dispatch(actionLogOutUser());
            }

            if (showSnackbar)
            	dispatch(
            		handleSetOpenCustomSnackbar(
            			true, 
            			{
            				message: res.message || 'خطا! لطفا مجدد تلاش کنید',
            				severity: 'error', 
            				vertical: 'top', 
            				horizontal: 'right'
            			}
        			)
        		);
            onError(res);
        }
    } catch (error) {
        if (showSnackbar)
        	dispatch(
        		handleSetOpenCustomSnackbar(
        			true, 
        			{
        				message: 'خطا در ارتباط با سرور. لطفاً مجدداً تلاش کنید.',
        				severity: 'error', 
        				vertical: 'top', 
        				horizontal: 'right'
        			}
    			)
    		);
        onError(error);
    }

    if (autoLoading) dispatch(handleSetBackdropLoading(false));
};

export default apiRequest;
